const sortResultsByType = (results: any[], typeOrdering: string[]) => {
  return [...results].sort((a, b) => {
    if (typeOrdering.indexOf(a.resultType) < typeOrdering.indexOf(b.resultType)) return -1;
    if (typeOrdering.indexOf(a.resultType) > typeOrdering.indexOf(b.resultType)) return 1;
    return 0;
  });
};

export default sortResultsByType;
